import { Card, CardActionArea, CardHeader, CardMedia, Divider, Grid } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import * as LAEnum from "../../data/LibraryAwareEnum";
import analytics from "../../utils/analytics";
import UserStar from "../UserStar/UserStar";
import ItemCardMenu from "./ItemsView/ItemCardMenu";
import { THUMBNAIL_NOT_AVAILABLE_URL } from "../../utils/thumbnailHelpers";

const useStyles = makeStyles(theme => ({
	card: {
		width: 250,
		height: 350,
		marginRight: theme.spacing(7),
		marginBottom: theme.spacing(7),
		borderRadius: 0
	},
	imageWrapper: {
		height: 275,
		background: `url("../../../../../Content/images/slickgrid/ajax-loader-small.gif") center/20px no-repeat`,
		overflow: "hidden"
	},
	cardMedia: {
		width: "auto",
		maxWidth: "100%",
		display: "block",
		marginTop: "0px",
		marginBottom: "0px",
		marginLeft: "auto",
        marginRight: "auto",

	},
    errorImage: {
        height: "auto",
        maxHeight: 275,
        width: "auto",
        maxWidth: 250,
    },
	cardHeader: {
		padding: theme.spacing(3),
		"& .MuiCardHeader-title": {
			...theme.typography.h6,
			width: 200
		},
		"& .MuiCardHeader-subheader": {
			...theme.typography.subtitle2,
			width: 200
		}
	}
}));

export default function ItemCard(props) {
	const classes = useStyles();

	const { item, imageSource, copyItem, deleteItem, href } = props;
	const [thumbnailErrorHandled, setThumbnailErrorHandled] = useState(false);
	const [showCardMenu, setShowCardMenu] = useState(false);

	const handleShowCardMenu = () => {
		setShowCardMenu(true);
	};

	const handleHideCardMenu = () => {
		setShowCardMenu(false);
	};

	const handleImageError = event => {
		if (!thumbnailErrorHandled) {
			event.target.src = THUMBNAIL_NOT_AVAILABLE_URL;
			event.target.style.background = "none";
		}

		setThumbnailErrorHandled(true);
	}

	const handleImageLoad = event => {
		event.target.style.background = "none";
	}

	// Logging callback passed down to the UserStar component. The UserStar component
	// invokes the callback, passing in the new state of the whether or not the item is Starred.
	const onStarredItemChange = (newStarredState) => {
		const logEvent = {
			type: analytics.eventTypes.FOLDERS.STAR_ITEM_CLICKED,
			properties: {
				item: {
					id: item.Id,
					name: item.Name
				},
				starOrUnstarred: newStarredState ? "starred" : "unstarred"
			}
		};
		analytics.logEvent(logEvent.type, logEvent.properties);
	}

	return (
		<Grid item>
			<Card
				className={classes.card}
				raised
				onMouseEnter={handleShowCardMenu}
				onMouseLeave={handleHideCardMenu}
			>
				<ItemCardMenu
					copyItem={copyItem}
					deleteItem={deleteItem}
					item={item}
					show={showCardMenu}
				/>
				<a href={href}>
					<CardActionArea>
						<Grid
							item
							container
							className={classes.imageWrapper}
							id={`wrapper-${item.Id}`}
							justify="center"
							alignItems="center"
						>
							<CardMedia
								className={thumbnailErrorHandled ? classes.errorImage :classes.cardMedia}
								id={`item-${item.Id}`}
								component="img"
								alt={item.Name}
								src={imageSource}
								onLoad={handleImageLoad}
								onError={handleImageError}
								title={item.Name}
							/>
						</Grid>
					</CardActionArea>
				</a>
				<Divider />
				<CardHeader
					className={classes.cardHeader}
					title={item.Name}
					titleTypographyProps={{ noWrap: true }}
					subheader={item.FormatName}
					subheaderTypographyProps={{ noWrap: true }}
					action={
						<UserStar
							isStarred={item.IsUserStarred}
							correlationId={item.UserStarredItemId}
							starContext={LAEnum.StarContext.PromotionItem}
							subContext={item.PromotionContextId}
							onClickCallback={onStarredItemChange}
						/>
					}
				/>
			</Card>
		</Grid >
	);
}

ItemCard.propTypes = {
	item: PropTypes.shape({
		Name: PropTypes.string,
		FormatName: PropTypes.string,
		Id: PropTypes.number
	}),
	imageSource: PropTypes.string,
	copyItem: PropTypes.func,
	deleteItem: PropTypes.func,
	href: PropTypes.string,
};
